import apiService from './apiService';

const marketplaceUrl = `${window._env_.MARKETPLACE_API_DOMAIN}`;
const platformUrl = `${window._env_.PLATFORM_API_DOMAIN}/v1`;

const getProfileDetails = (accessToken) => {
  const url = `${marketplaceUrl}/v2/profile`;
  return apiService.get(url, { accessToken });
};

const postInviteSignup = (accessToken, type) => {
  const url = `${platformUrl}/auth/invite/sign-up`;
  return apiService.post(url, { type }, { accessToken });
};

export { getProfileDetails, postInviteSignup };
